import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const resetPassword = data => post(URL.RESET_PASSWORD, data, {skipInterceptor: true});

export const forgetPassword = data => post(URL.FORGET_PASSWORD, data, {skipInterceptor: true})